import { render, staticRenderFns } from "./OogDgInquiryPop.vue?vue&type=template&id=b974eed4&scoped=true"
import script from "./OogDgInquiryPop.vue?vue&type=script&lang=js"
export * from "./OogDgInquiryPop.vue?vue&type=script&lang=js"
import style0 from "./OogDgInquiryPop.vue?vue&type=style&index=0&id=b974eed4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b974eed4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b974eed4')) {
      api.createRecord('b974eed4', component.options)
    } else {
      api.reload('b974eed4', component.options)
    }
    module.hot.accept("./OogDgInquiryPop.vue?vue&type=template&id=b974eed4&scoped=true", function () {
      api.rerender('b974eed4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/OogDgInquiryPop.vue"
export default component.exports